import { baseUrl } from "../../common/config";
import { http } from "../../common/helpers";

export const getQuickWinsList = async ({ ...params }) => {
  const { data } = await http.get(`${baseUrl}/api/assessments/quickwin/all`, {
    params,
  });
  return data.data;
};
